<template>
  <div class="container-fluid pt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div class="page-wrapper">
      <div class="d-flex justify-content-between mb-4 mt-3 align-items-center">
        <router-link to="/dispatch">
          <span class="d-flex back-btn">
            <IconArrowBack />
            {{ $t("backToAllDispatch") }}
          </span>
        </router-link>
        <h5>{{ $t("trackingCode") }}: {{ trackId }}</h5>
      </div>
      <div v-if="singledevice && singledevice.data" class="row">
        <div class="col-lg-4 col-md-5">
          <div class="card" style="height: 8.4rem">
            <div
              class="card-body p-20 d-flex align-items-center justify-content-between"
            >
              <div
                class="icon-container icon-devices position-absolute"
                style="background: #DEE2EB;top: 15px;"
              >
                <IconDeviceDispatch />
              </div>
              <div class="d-flex flex-column align-items-center ml-auto">
                <p class="">{{ $t("devices") }}</p>
                <h1 class="">{{ imeis.length }}</h1>
              </div>
            </div>
          </div>
          <div class="mt-2 mb-3">
            <div class="input-group">
              <select class="form-control" v-model="imei">
                <option v-for="(imei, i) in imeis" :value="imei" :key="i">{{
                  imei
                }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="card" style="">
                <div class="card-body">
                  <h4 class="">{{ singledevice.data.settings.name }}</h4>
                  <h5 class="gray4">
                    <div class="row">
                      <div class="col-4">
                        <b>{{ $t("dev-tag") }}:</b>
                      </div>
                      <div class="col-8">
                        {{ singledevice.data.deviceTag }}
                      </div>
                    </div>
                  </h5>
                  <h5 class="gray4">
                    <div class="row">
                      <div class="col-4 gray4"><b>Imei:</b></div>
                      <div class="col-8 gray4">
                        {{ singledevice.data.imei }}
                      </div>
                    </div>
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12">
              <div class="card" style="">
                <div class="card-body">
                  <h4 class="">{{ $t("customerDetails") }}</h4>
                  <h5 class="gray4">
                    <div class="row">
                      <div class="col-4">
                        <b>{{ $t("name") }}:</b>
                      </div>
                      <div class="col-8">
                        {{ customerDetails.name }}
                      </div>
                    </div>
                  </h5>
                  <h5 class="gray4">
                    <div class="row">
                      <div class="col-4 gray4">
                        <b>{{ $t("address") }}:</b>
                      </div>
                      <div class="col-8 gray4">
                        {{ customerDetails.address }}
                      </div>
                    </div>
                  </h5>
                  <h5 class="gray4">
                    <div class="row">
                      <div class="col-4 gray4">
                        <b>{{ $t("email") }}:</b>
                      </div>
                      <div class="col-8 gray4">
                        {{ customerDetails.email }}
                      </div>
                    </div>
                  </h5>
                  <h5 class="gray4">
                    <div class="row">
                      <div class="col-4 gray4">
                        <b>{{ $t("phoneNo") }}:</b>
                      </div>
                      <div class="col-8 gray4">
                        {{ customerDetails.phone }}
                      </div>
                    </div>
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="card" style="overflow-y: auto; height: 100%">
                <div class="card-body">
                  <div
                    class="row py-2"
                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="col-2">
                      <span
                        class="text-primary"
                        style="font-size: 3rem"
                        v-if="
                          singledevice.data.type !== 'gateway' &&
                            singledevice.data.stats.temperature
                        "
                        ><SnowFlakeIcon
                      /></span>
                    </div>
                    <div
                      class="col-4 align-items-center justify-content-center"
                      style="display: flex"
                    >
                      <h2
                        class="mb-0"
                        v-if="
                          singledevice.data.type !== 'gateway' &&
                            singledevice.data.stats.temperature
                        "
                      >
                        {{ singledevice.data.stats.temperature }}<sup>°</sup>C
                      </h2>
                    </div>
                    <div
                      class="col-8 justify-content-center"
                      style="display: flex; flex-direction: column"
                    >
                      <p style="font-size: 0.9rem" class="gray4 mb-0">
                        {{ $t("last-read") }}
                      </p>
                      <p
                        v-if="singledevice.data.stats.createdAt"
                        style="font-size: 0.9rem"
                        class="gray3 mb-0"
                      >
                        {{ getDate(singledevice.data.stats.createdAt) }}
                      </p>
                      <p v-else style="font-size: 0.9rem" class="gray3 mb-0">
                        {{ $t("no-read") }}
                      </p>
                    </div>
                  </div>

                  <div
                    class="row mx-2 py-2"
                    v-if="
                      singledevice.data.type === 'mote' ||
                        singledevice.data.type === 'lora'
                    "
                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="col-8 pl-0 text-muted">{{ $t("humid") }}</div>
                    <div class="col-4 font-medium">
                      <span>{{ singledevice.data.stats.humidity }}%</span>
                    </div>
                  </div>

                  <div
                    class="row mx-2 py-2"
                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="col-8 pl-0 text-muted">{{ $t("batt") }}</div>
                    <div class="col-4 font-medium">
                      <span
                        v-if="singledevice.data.stats.battery < 0"
                        class="red-text"
                        >{{ $t("emp") }}</span
                      >
                      <span v-else-if="singledevice.data.stats.battery > 100"
                        >100%</span
                      >
                      <span v-else>{{ singledevice.data.stats.battery }}%</span>
                      <span
                        v-if="singledevice.data.stats.charging === true"
                        class="green-text"
                        ><i class="mdi mdi-battery-charging"></i
                      ></span>
                    </div>
                    <hr />
                  </div>

                  <div
                    class="row mx-2 py-2"
                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="col-8 pl-0 text-muted">
                      {{ $t("min-temp") }}
                    </div>
                    <div class="col-4 font-medium">
                      <span
                        >{{ singledevice.data.settings.minTemp
                        }}<sup>°</sup>C</span
                      >
                    </div>
                  </div>

                  <div
                    class="row mx-2 py-2"
                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="col-8 pl-0 text-muted">
                      {{ $t("max-temp") }}
                    </div>
                    <div class="col-4 font-medium">
                      <span
                        >{{ singledevice.data.settings.maxTemp
                        }}<sup>°</sup>C</span
                      >
                    </div>
                  </div>

                  <div
                    class="row mx-2 py-2"
                    v-if="singledevice.data.type === 'box'"
                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="col-8 pl-0 text-muted">
                      {{ $t("set-point") }}
                    </div>
                    <div class="col-4 font-medium">
                      <span
                        >{{ singledevice.data.settings.preset
                        }}<sup>°</sup>C</span
                      >
                    </div>
                  </div>

                  <div
                    class="row mx-2 py-2"
                    v-if="
                      singledevice.data.type === 'mote' ||
                        singledevice.data.type === 'lora'
                    "
                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="col-8 pl-0 text-muted">
                      {{ $t("min-humid") }}
                    </div>
                    <div class="col-4 font-medium">
                      <span>{{ singledevice.data.settings.minHumidity }}%</span>
                    </div>
                  </div>

                  <div
                    class="row mx-2 py-2"
                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
                    v-if="
                      singledevice.data.type === 'mote' ||
                        singledevice.data.type === 'lora'
                    "
                  >
                    <div class="col-8 pl-0 text-muted">
                      {{ $t("max-humid") }}
                    </div>
                    <div class="col-4 font-medium">
                      <span>{{ singledevice.data.settings.maxHumidity }}%</span>
                    </div>
                  </div>

                  <div
                    class="row mx-2 py-2"
                    v-if="
                      singledevice.data.type === 'mote' ||
                        singledevice.data.type === 'lora'
                    "
                  >
                    <div class="col-8 pl-0 text-muted">
                      {{ $t("sig-strength") }}
                    </div>
                    <div class="col-4 font-medium">
                      <span
                        v-if="
                          singledevice.stats.length > 0 &&
                            singledevice.stats[singledevice.stats.length - 1]
                              .moteAddress
                        "
                        >{{ getSignalStrength }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-lg-8 col-md-7"
          v-if="singledevice.data.type !== 'gateway'"
        >
          <div class="card" style="height: 50%">
            <div class="card-body">
              <div
                class="p-20"
                v-if="this.singledevice.stats.length == 0"
                align="center"
              >
                <h4 class="text-muted">
                  {{ $t("no-dev-today") }}
                </h4>
              </div>
              <div
                class="p-20"
                v-else-if="singledevice.data.subscription.expired"
                align="center"
              >
                <h4 class="text-muted">
                  <!-- {{ $t("no-dev-today") }} -->
                  Temperature Chart Unavailable
                </h4>
              </div>

              <div v-else>
                <div
                  class="d-flex justify-content-space-around col-md-10 col-lg-6 mx-auto"
                  v-if="
                    singledevice.data &&
                      (singledevice.data.type == 'mote' ||
                        singledevice.data.type === 'lora' ||
                        singledevice.data.type === 'gps-vt')
                  "
                >
                  <div class="btn-container">
                    <button
                      @click="
                        tempGraph = true;
                        humiGraph = false;
                      "
                      :disabled="tempGraph == true"
                      id="graphselect"
                    >
                      {{ $t("temp") }}
                    </button>
                  </div>
                  <div class="btn-container">
                    <button
                      @click="
                        tempGraph = false;
                        humiGraph = true;
                      "
                      :disabled="tempGraph == false"
                      id="graphselect"
                    >
                      {{ $t("humid") }}
                    </button>
                  </div>
                </div>
                <div>
                  <CombinedChart
                    :tempGraph="tempGraph"
                    :humiGraph="humiGraph"
                    :stats="singledevice.stats"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card" style="height: 50%">
            <!-- <LMap
              ref="map"
              :zoom.sync="zoom"
              :options="mapOptions"
              :center="center"
              :bounds="bounds"
              :min-zoom="minZoom"
              :max-zoom="maxZoom"
            >
              <l-control-zoom position="topright" />

              <LTileLayer :url="url"></LTileLayer>
              <LLayerGroup layer-type="overlay" name="Devices">
                <LMarker :lat-lng="center"
                  ><l-icon :icon-anchor="[18, 0]">
                    <img
                      src="../../assets/images/marker-good.svg"
                      alt=""
                      height="40px"
                    />
                  </l-icon>
                </LMarker>
              </LLayerGroup>
            </LMap> -->
            <l-map
              style="height: 100%"
              :zoom="zoom"
              :center="center"
              :bounds="bounds"
              :min-zoom="minZoom"
            >
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              ></l-tile-layer>
              <l-marker :lat-lng="center" @click="centerMap">
                <l-icon :icon-anchor="[18, 0]">
                  <img
                    src="../../assets/images/marker-good.svg"
                    alt=""
                    height="40px"
                  />
                </l-icon>
              </l-marker>
            </l-map>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import moment from "moment";
import IconDeviceDispatch from "../../components/Iconsvg/IconDeviceDispatch.vue";
import IconArrowBack from "../../components/Iconsvg/IconArrowBack.vue";
import SnowFlakeIcon from "../../components/Iconsvg/SnowFlakeIcon.vue";
// import CombinedChart from "../../components/Devices/CombinedChart";
import "vue-loading-overlay/dist/vue-loading.css";
import "leaflet/dist/leaflet.css";

import {
  LMap,
  LTileLayer,
  LMarker,
  //   LPopup,
  LIcon,
  //   LControlZoom,
  //   LLayerGroup,
  // LControlLayers,
} from "vue2-leaflet";
import { latLngBounds } from "leaflet";

export default {
  name: "SingleDispatch",
  data() {
    return {
      tempGraph: true,
      humiGraph: false,
      isLoading: true,
      fullPage: true,
      lastreaddate: "",
      datecreated: "",
      license: "",
      mssg: "",
      Errormssg: "",
      deviceOn: true,
      rate: "",
      customerDetails: {},
      imeis: [],
      id: "",
      stats: [],
      deviceInfo: {},
      tempHumid: {},
      latLng: {},
      singledevice: {},
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      // url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      zoom: 20,
      center: [6.21024000000001, 3.4570065],
      bounds: null,
      mapOptions: {
        zoomControl: false,
        attributionControl: false,
        zoomSnap: true,
      },
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      minZoom: 4,
      imei: "",
      trackId: "",
    };
  },
  components: {
    Loading,
    IconArrowBack,
    SnowFlakeIcon,
    CombinedChart: () =>
      import(
        /* webpackPrefetch: true */ "../../components/Devices/CombinedChart"
      ),
    IconDeviceDispatch,
    LMap,
    LTileLayer,
    LMarker,
    // LPopup,
    LIcon,
    // LControlZoom,
    // LLayerGroup,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters(["token", "profile", "lastPageData", "dispatchByTrackId"]),
    getSignalStrength() {
      let val = this.singledevice.stats[this.singledevice.stats.length - 1]
        .moteAddress.signalStrength;
      function between(x, min, max) {
        return x >= min && x <= max;
      }
      let strength;
      if (between(val, -120, -95.0)) {
        strength = "Extremely Bad";
      }
      if (between(val, -95.01, -85.0)) {
        strength = "Bad";
      }
      if (between(val, -85.01, -75.0)) {
        strength = "Average";
      }
      if (between(val, -75.01, -65.0)) {
        strength = "Good";
      }
      if (between(val, -65.01, -55.0)) {
        strength = "Very Good";
      }
      if (between(val, -55.01, 0.0)) {
        strength = "Excellent";
      }

      return strength;
    },
  },
  methods: {
    ...mapActions([
      "updatePageNumber",
      "getDispatchRecordById",
      "trackDispatchDevice",
    ]),
    closeModal() {
      this.isOpen = false;
    },
    getDate(date) {
      return moment(date, "x", true).format("ddd, MMM Do YYYY, hh:mm a");
    },
    setBounds() {
      this.bounds = latLngBounds([this.center]);
    },
    getDeviceByImei(imei) {
      this.trackDispatchDevice({ id: this.id, imei }).then((res) => {
        const data = res.data.data;
        this.stats = res.data.data.stats;
        this.tempHumid = res.data.data.device.stats;
        this.deviceInfo = {
          deivceTag: res.data.data.device.deviceTag,
          imei: res.data.data.device.imei,
        };
        this.isLoading = false;
        this.singledevice.data = res.data.data.device;
        this.singledevice.stats = res.data.data.stats;
        this.center = [data.device.stats.latitude, data.device.stats.longitude];
      });
    },
    centerMap() {
      this.center = [this.tempHumid.latitude, this.tempHumid.longitude];
      this.setBounds();
      this.zoom = 20;
    },
  },
  mounted() {
    this.getDispatchRecordById(this.$route.params.id).then((res) => {
      this.customerDetails = res.data.data.dispatch.contact;
      this.id = res.data.data.dispatch._id;
      this.trackId = res.data.data.dispatch.trackingId;
      const firstImei = res.data.data.item.devices[0];
      this.imei = firstImei;
      const items = res.data.data.items;
      this.getDeviceByImei(firstImei);
      //   Get all Device Imei
      const allImeis = [];
      const foundImei = {};
      const itemsDevices = items.map(({ devices }) => devices);
      const itemsFlat = itemsDevices.flat();

      const length = itemsFlat.length;

      for (let i = 0; i < length; i++) {
        if (foundImei[itemsFlat[i]] !== undefined) {
          continue;
        } else {
          foundImei[itemsFlat[i]] = true;
          allImeis.push(itemsFlat[i]);
        }
      }
      this.imeis = allImeis;
    });
  },
  watch: {
    imei: {
      handler: function() {
        this.isLoading = true;
        this.getDeviceByImei(this.imei);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.btn-container {
  display: flex;
  justify-content: center;
  width: 50%;
}
#graphselect {
  background-color: inherit;
  border: none;
  color: #213e7a;
  padding: 7px 25px;
  border-radius: 30px;
  outline: none;
}
#graphselect:hover {
  background-color: #213e7a;
  color: white;
}
#graphselect:disabled,
#graphselect[disabled] {
  background-color: #DEE2EB;
  color: #213e7a;
}
.green-text {
  color: #213e7a;
}

.succeed {
  background: #ffe6cc;
  padding: 15px 15px 7px;
  border: 1px solid #f0ac66;
  margin-bottom: 2rem;
  border-radius: 3px;
}
.succeed p {
  color: #f0ac66;
}
.back-btn {
  color: #213e7a;
  align-items: center;
  font-size: 1rem;
  column-gap: 0.5rem;
  cursor: pointer;
}
</style>

<i18n>
{
	"en": {
		"add": "Added on",
		"address": "Address",
		"alert": "Alert!",
		"backToAllDispatch": "Back to All Dispatch",
		"cali": "Calibration Expriry Date",
		"customerDetails": "Customer Details",
		"dev-tag": "Device Tag",
		"email": "Email",
		"emp": "Empty",
		"last-read": "Last Read on",
		"name": "Name",
		"no-dev-today": "No Temperature/Humidity data available for today",
		"no-read": "No readings yet",
		"phoneNo": "Phone no",
		"read-on": "read on",
		"set-point": "Set Point",
		"sig-strength": "Signal Strength",
		"trackingCode": "Tracking Code"
	},
	"es": {
		"add": "Añadido",
		"address": "Dirección",
		"alert": "¡Alerta!",
		"backToAllDispatch": "Volver a Todo Despacho",
		"cali": "Date d'expiration de l'étalonnage",
		"customerDetails": "Detalles del cliente",
		"dev-tag": "Etiqueta de dispositivo",
		"email": "Email",
		"emp": "vacío",
		"last-read": "Última lectura en",
		"name": "Nombre",
		"no-dev-today": "No hay datos de temperatura / humedad disponibles para hoy",
		"no-read": "Aún no hay lecturas",
		"phoneNo": "TELÉFONO NO",
		"read-on": "sigue leyendo",
		"set-point": "Punto fijo",
		"sig-strength": "Intensidad de señal",
		"trackingCode": "Codigo de localización"
	},
	"fr": {
		"add": "Ajouté sur",
		"address": "Adresse",
		"alert": "alerte!",
		"backToAllDispatch": "Retour à toutes les expéditions",
		"cali": "Date d'expiration de l'étalonnage",
		"customerDetails": "Détails du client",
		"dev-tag": "Balise d'appareil",
		"email": "Email",
		"emp": "vide",
		"last-read": "Dernière lecture",
		"name": "Prénom",
		"no-dev-today": "Aucune donnée de température/humidité disponible pour aujourd'hui",
		"no-read": "Pas encore de lectures",
		"phoneNo": "Pas de téléphone",
		"read-on": "Continuer à lire",
		"set-point": "Point de consigne",
		"sig-strength": "Force du signal",
		"trackingCode": "Code de suivi"
	},
	"sw": {
		"add": "Imeongezwa",
		"address": "Anwani",
		"alert": "Tahadhari!",
		"backToAllDispatch": "Rudi kwa Utumaji Wote",
		"cali": "Tarehe ya Kusafirishwa kwa Urekebishaji",
		"customerDetails": "Maelezo ya Wateja",
		"dev-tag": "Lebo ya Kifaa",
		"email": "Barua pepe",
		"emp": "tupu",
		"last-read": "Iliyosomwa Mwisho",
		"name": "Jina",
		"no-dev-today": "Hakuna data ya Halijoto/Unyevu inayopatikana kwa leo",
		"no-read": "Bado hakuna masomo",
		"phoneNo": "Namba ya simu",
		"read-on": "soma endelea",
		"set-point": "Weka Pointi",
		"sig-strength": "Nguvu ya Ishara",
		"trackingCode": "Msimbo wa Ufuatiliaji"
	}
}
</i18n>
